import {
  Grid,
  Typography,
  Box,
  Button,
  IconButton,
  Modal,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';
import React, { useState } from 'react';

import { getResplanCsv } from '../../../../packages/common/api';
import DownloadButton from '../../../../packages/common/shared-ui/src/icons/DownloadButton';
import ProjectSettingsIcons from '../../../../packages/common/shared-ui/src/icons/ProjectSettingsIcons';
import { useTranslation } from '../../../../packages/common/utils/getLocalString';
import ResourcePlanFilter from '../ResourcePlanFilter/ResourcePlanFilter';
import ResourcePlanModal from '../ResourcePlanModal/ResourcePlanModal';

// Original class: headerWrap
const StyledHeaderWrap = styled(Grid)(theme => ({
  display: 'block !important',
}));
// Original class: pageTitle
const StyledPageTitle = styled(Grid)(theme => ({
  float: 'left',
  paddingTop: '10px',
  marginRight: '32px !important',
  width: 'auto !important',
}));
// Original class: buttonSectionWrap
const StyledButtonSectionWrap = styled(Grid)(theme => ({
  float: 'right',
  position: 'relative',
  width: 'auto !important',
}));
const ResourcePlanHeader = ({
  pageTitle,
  headerFilters,
  setRefreshKey,
  setQuery,
  setFetchedQuery,
  query,
  setIsSaving,
  setIsLoading,
  setIsClearing,
  incorrectDates,
  fetchedQuery,
  refreshKey,
}) => {
  const getLocalString = useTranslation();

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const downloadResplanCsv = async () => {
    try {
      const data = await getResplanCsv();
      const url = window.URL.createObjectURL(
        new Blob(['\ufeff', data], { type: 'text/csv;charset=utf-8;' }),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `resplan-${dayjs().format('YYYY-MM-DD')}`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      link.remove();
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <StyledHeaderWrap
      container
      wrap='nowrap'
      sx={{
        position: 'relative',
      }}
    >
      <StyledPageTitle
        container
        sx={{
          marginBottom: 0,
          alignItems: 'center',
        }}
      >
        <Typography variant='h1'>{pageTitle}</Typography>
      </StyledPageTitle>
      <StyledButtonSectionWrap container>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              marginRight: 0.5,
            }}
          >
            {incorrectDates?.length != 0 ? (
              <Button
                disableRipple
                disabled
                variant='cutGreyPrimary'
                onClick={() => setIsSaving(true)}
              >
                {getLocalString('buttons', 'save')}
              </Button>
            ) : (
              <Button
                disableRipple
                variant='cutGreyPrimary'
                onClick={() => setIsSaving(true)}
              >
                {getLocalString('buttons', 'save')}
              </Button>
            )}
          </Box>
          <Button
            disableRipple
            variant='cutGreySecondary'
            onClick={() => setIsClearing(true)}
          >
            <Typography variant='h5'>
              {getLocalString('buttons', 'clear')}
            </Typography>
          </Button>
        </Box>
        <Box
          sx={{
            marginLeft: 3,
          }}
        >
          <Button
            variant='defaultGreyPrimaryWithIcon'
            disableRipple
            onClick={handleOpen}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginRight: 1.5,
              }}
            >
              <ProjectSettingsIcons
                color='#7174AC'
                width={24}
                height={24}
                viewBox='0 0 20 20'
              />
            </Box>
            <Typography
              variant='h4'
              sx={{
                fontWeight: 600,
              }}
            >
              {getLocalString('buttons', 'params')}
            </Typography>
          </Button>
        </Box>
        <IconButton onClick={downloadResplanCsv}>
          <DownloadButton width={24} height={24} viewBox='0 0 24 24' />
        </IconButton>
        <ResourcePlanModal
          open={open}
          handleClose={handleClose}
          setRefreshKey={setRefreshKey}
          setFetchedQuery={setFetchedQuery}
          query={query}
          setQuery={setQuery}
          setIsLoading={setIsLoading}
        />
      </StyledButtonSectionWrap>
      <ResourcePlanFilter
        filters={headerFilters}
        setQuery={setQuery}
        topFilters={3}
        pageTitle={pageTitle}
        setFetchedQuery={setFetchedQuery}
        query={query}
        fetchedQuery={fetchedQuery}
        refreshKey={refreshKey}
      />
    </StyledHeaderWrap>
  );
};

export default ResourcePlanHeader;
